import React from 'react';
import SkillForm from './SkillForm';
import Stack from 'components/common/Stack';
import { trackComponent } from 'telemetry/AppInsights';

const NewSkillPage = props => {
  const handleSubmit = response => {
    props.history.push(`/skills/${response.id}`);
  };

  const handleCancel = () => {
    props.history.push('/skills');
  };

  return (
    <Stack>
      <SkillForm isCreateMode onSubmit={handleSubmit} onCancel={handleCancel} />
    </Stack>
  );
};

export default trackComponent(NewSkillPage, 'New Skill Page');
